import BaseService from 'services/BaseService';

export default class ItemAssetService extends BaseService {
	_type = 'item-asset';
	_typeKey = 'type';
}
